import api from './api';

export const getAllClasses = async () => {
    try {
        const response = await api.get('/classes');
        return response.data;
    } catch (error) {
        console.error("Error fetching classes:", error);
        throw error;
    }
};

export const createClass = async (name) => {
    try {
        const response = await api.post('/classes', { name });
        return response.data;
    } catch (error) {
        console.error("Error creating class:", error);
        throw error;
    }
};

export const updateClass = async (id, data) => {
    try {
        const response = await api.put(`/classes/${id}`, data);
        return response.data;
    } catch (error) {
        console.error("Error updating class:", error);
        throw error;
    }
};

export const assignTeacherToClass = async (classId, teacherId) => {
    try {
        const response = await api.put(`/classes/${classId}/assign-teacher`, { teacher_id: teacherId });
        return response.data;
    } catch (error) {
        console.error("Error assigning teacher:", error);
        throw error;
    }
};

export const saveAllClassTeacherAssignments = async (assignments) => {
    // This correctly calls POST /api/classes/assign-teachers
    const response = await api.post('/classes/assign-teachers', { assignments });
    return response.data;
};

export const saveAllAttendanceModes = async (modes) => {
    const response = await api.post('/classes/update-attendance-modes', { modes });
    return response.data;
};

export const getClassSummary = async (classId) => {
    try {
        const response = await api.get(`/classes/${classId}/summary`);
        return response.data;
    } catch (error) {
        console.error(`Error fetching class summary for class ${classId}:`, error);
        throw error;
    }
};